export default class MapeadorCaixaChecagem {
    processar({ campo, atribuicoes, dadoCampo }) {
        campo.opcoes.forEach((opcao) => {
            if (opcao.mapeamento) {
                atribuicoes[opcao.mapeamento] = dadoCampo[opcao.nome]
                    ? "Sim"
                    : "Não";
            }
        });
    }
}
